import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BaseLayerService } from './baselayer-dropdown/baselayer.service';
import { FlcBaseLayer } from './flc-base-layer.model';
import { FlcControlLayer } from './flc-control-layer.model';
import { LayerControlService } from './layer-control/layer-control.service';
import { LayerSwitcherService } from './layerswitcher.service';


@Component({
  selector: 'app-layerswitcher',
  templateUrl: './layerswitcher.component.html',
  styleUrls: ['./layerswitcher.component.css'],
  providers: [ BaseLayerService, LayerControlService ]
})
export class LayerswitcherComponent implements OnInit, OnDestroy {

  isOpen = false;
  isVisible = true;
  isLegendVisible = false;
  isMeasureVisible = false;

  setSelectedBaseLayerSubscription: Subscription;
  setSelectedRasterLayerSubscription: Subscription;
  layerChangedSubscription: Subscription;
  closeLayerSwitcherOverlaySubscription: Subscription;

  titleLayers: string;
  titleVisibleOff: "";
  titleVisible: "";
  titleLegendVisible: "";
  titleLegendVisibleOff: "";
  titleMeasureStart: "";
  titleMeasureStop: "";

  constructor(public lsService: LayerSwitcherService,
     private blService: BaseLayerService, private layerService: LayerControlService,
     public translate: TranslateService) {
      }

  ngOnDestroy(): void {
    if (this.setSelectedBaseLayerSubscription) this.setSelectedBaseLayerSubscription.unsubscribe();
    if (this.setSelectedRasterLayerSubscription) this.setSelectedRasterLayerSubscription.unsubscribe();
    if (this.layerChangedSubscription) this.layerChangedSubscription.unsubscribe();
    if (this.closeLayerSwitcherOverlaySubscription) this.closeLayerSwitcherOverlaySubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.translate.get(['map_button.layers_title', 'map_button.layer_set_visible', 'map_button.layer_set_visible_off',
    'map_button.layer_set_visible_legend', 'map_button.layer_set_measure_start', 'map_button.layer_set_measure_stop']).subscribe((translations: string) => {

      this.titleLayers = translations['map_button.layers_title'];
      this.titleVisible = translations['map_button.layer_set_visible_off'];
      this.titleVisibleOff = translations['map_button.layer_set_visible'];
      this.titleLegendVisible = translations['map_button.layer_set_visible_legend'];
      this.titleMeasureStart = translations['map_button.layer_set_measure_start'];
      this.titleMeasureStop = translations['map_button.layer_set_measure_stop'];
    });

    this.lsService.preSetSelectedBaseLayer(null);

    this.setSelectedBaseLayerSubscription = this.blService.setSelectedBaseLayer.subscribe(
      (bl: FlcBaseLayer) =>
      {
        this.lsService.preSetSelectedBaseLayer(bl);
      }
    );

    this.setSelectedRasterLayerSubscription = this.layerService.layerChanged.subscribe(
      (bl: FlcControlLayer) =>
      {
        this.lsService.layerchanged.next(bl);
      }
    );

    this.closeLayerSwitcherOverlaySubscription = this.lsService.closeLayerSwitcherOverlay.subscribe(() => {
      this.isOpen = false;
    });

  }

  switchVisibleParentLayer()
  {
    this.isVisible = !this.isVisible;
    this.lsService.toSetVisibleParentLayer(this.isVisible);
  }

  switchVisibleLegend()
  {
    this.isLegendVisible = !this.isLegendVisible;
    if (this.isLegendVisible && this.isOpen)
    {
      this.switchVisibleLayerSelection();
    }
    if (this.isLegendVisible && this.isMeasureVisible)
    {
      this.switchVisibleMeasure();
    }

    this.lsService.toSetVisibleLegends(this.isLegendVisible);
  }

  switchVisibleMeasure()
  {
    this.isMeasureVisible = !this.isMeasureVisible;
    if (this.isMeasureVisible && this.isOpen)
    {
      this.switchVisibleLayerSelection();
    }
    if (this.isMeasureVisible && this.isLegendVisible)
    {
      this.switchVisibleLegend();
    }

    this.lsService.toSetVisibleMeasure(this.isMeasureVisible);
  }

  switchVisibleLayerSelection()
  {
    this.isOpen = !this.isOpen;
    if (this.isOpen && this.isLegendVisible)
    {
      this.switchVisibleLegend();
    }
    if (this.isOpen && this.isMeasureVisible)
    {
      this.switchVisibleMeasure();
    }
  }
}

